// Section 5: memory keeps the last 8 seasons of notable things done to a person.
import type { MemoryEntry, Person, PhaseContext } from '../../core/types';

export function remember(ctx: PhaseContext, person: Person, entry: MemoryEntry): void {
  const oldest = ctx.season.turn - ctx.cfg.people.memorySeasons + 1;
  const kept = person.memory.filter((m) => m.turn >= oldest);
  kept.push(entry);
  person.memory = kept;
}
